export default __webpack_public_path__ + "img/caikuma_invitation_campaign.1c2c3515.webp";